import React, {Fragment, useContext, useEffect, useState} from "react";
import {Formik, Form} from "formik";

import {customerAutomotorValidation} from "../FormsModel/validationSchema";
import {customerAutomotorInitialValues} from "../FormsModel/formInitialValues";
import formModel from '../FormsModel/formModel';

import VehiculoForm from './Forms/VehiculoForm';
import EmisionForm from "./Forms/EmisionForm";
import TitularForm from "./Forms/TitularForm";
import SolicitudForm from "./Forms/SolicitudForm";
import Axios from "axios";
import ProgressBar from "../../ProgressBar";
import CotizacionSuccess from "./CotizacionSuccess";
import Loading from "../../Loading";
import ClienteDirectoContext from "../../../context/ClienteDirectoContext";
import {formatPhoneNumberIntl} from "react-phone-number-input";
import EmisionSuccess from "./EmisionSuccess";
import {ReactComponent as IconCar} from '../../../assets/products/auto.svg';
import moment from "moment";
import {fillAdvancedConfigByCompany} from "./AuxFunctions/fillAdvancedConfigByCompany";
import {buildLocationCode} from "../../Utils/buildLocationCode";
import AutomotorContextProvider from "../../../context/products/AutomotorContext/AutomotorContextProvider";
import loadAutomotorData from "../../../context/products/AutomotorContext/loadAutomotorData";
import fetchContextData from "../../../context/utils/fetchContextData";
import AutomotorContext from "../../../context/products/AutomotorContext/AutomotorContext";
import {ContactText} from "../../ContactText/ContactText";
import {companiesDict, companiesIdDict} from "../../../constants/companiesDict"
import {polkoClientsActiveProducts} from "../../../constants/polkoClientsActiveProducts";
import GenericDataContext from "../../../context/GenericDataContext";

const {formField} = formModel;

function _renderStepContent(step, cotizacionResponse, finalValues, modelos, setModelos, setActiveStep, setEmisionResponse, emisionResponse, currentProduct, localidadOptions, setLocalidadOptions, provinciasOptions, setProvinciasOptions) {
    switch (step) {
        case 0:
            return <VehiculoForm formField={formField} modelos={modelos} setModelos={setModelos}
                                 localidadOptions={localidadOptions} setLocalidadOptions={setLocalidadOptions}
                                 provinciasOptions={provinciasOptions} setProvinciasOptions={setProvinciasOptions}/>
        case 1:
            return <div>
                {(cotizacionResponse !== null && finalValues !== null)
                    ?
                    <CotizacionSuccess finalValues={finalValues}
                                       currentProduct={currentProduct}
                                       cotizacionResponse={cotizacionResponse}
                                       BottomInfo={() => ContactText({withThanks: true})}/>
                    : (
                        <div className="form__titleContainer">
                            <Loading title={"¡Gracias por cotizar!"} Subtitle={() => ContactText({withThanks: false})}/>
                        </div>
                    )
                }
            </div>
        case 2:
            return <TitularForm formField={formField}/>
        case 3:
            return <EmisionForm formField={formField}/>
        case 4:
            return <SolicitudForm formField={formField} cotResponse={cotizacionResponse}/>
        case 5:
            return <div style={{margin: "32px 16px"}}>
                {emisionResponse !== null
                    ?
                    <EmisionSuccess emisionResponse={emisionResponse} setActiveStep={setActiveStep}
                                    setEmisionResponse={setEmisionResponse} finalValues={finalValues}/>
                    : (
                        <Fragment>
                            <p className="form__title">
                                Emitiendo...
                            </p>
                            <Loading/>
                            <p className="form__text--center">
                                Esto puede demorar hasta 60 segundos.
                            </p>
                        </Fragment>
                    )
                }
            </div>
        default:
            return <div>Not Found</div>;
    }
}

function CheckoutCotizar({steps, activeStep, setActiveStep}) {
    const {polkoClientes} = useContext(GenericDataContext)
    const currentValidationSchema = customerAutomotorValidation[activeStep];
    const {vehicleDetails} = useContext(AutomotorContext);
    const [cotizacionResponse, setCotizacionResponse] = useState(null)
    const [emisionResponse, setEmisionResponse] = useState(null)
    const [finalValues, setFinalValues] = useState(null);
    const [modelos, setModelos] = useState([]);
    const [localidadOptions, setLocalidadOptions] = useState([]);
    const [provinciasOptions, setProvinciasOptions] = useState([]);
    const {activeProducts: ctxActiveProducts, idRowPaginasPolkista} = useContext(ClienteDirectoContext) || {};
    const activeProducts = ctxActiveProducts || polkoClientsActiveProducts;
    const currentProduct = 'vehiculo'
    const companiesId = activeProducts[currentProduct]['codigos_aseguradoras'].map((el) => el['id_aseguradora'])

    async function _cotizarForm(values, actions) {

        let url = process.env.REACT_APP_BACK_SERVER + (
            polkoClientes ? '/polkoClientes/cotizacion/automotor' : '/newcotizar'
        );

        const selectedLocation = localidadOptions.find(
            (localidad) => localidad.value === values.codigosLocalidad
        );
        if (!values.nombreLocalidad)
            values.nombreLocalidad = selectedLocation
                ? selectedLocation.label.split(') ')[1]
                : "";
        const companiesName = companiesId.map(company => companiesIdDict[company])
        const locationCodes = await buildLocationCode(companiesName, values.codigosLocalidad, companiesDict);
        values.codigoPostal = parseInt(values.codigoPostal);
        let jsonData = {
            ...(!polkoClientes && {"idCanalDigital": idRowPaginasPolkista})
        };
        const selectedMarca = values.vehiculo.marca;
        const marcaAuto = typeof selectedMarca === 'string' ? parseInt(selectedMarca.split('-')[0]) : selectedMarca

        values.vehiculo = {
            ...values.vehiculo,
            ...vehicleDetails.current
        }

        jsonData = {
            ...jsonData,
            "vehiculo": {
                ...values.vehiculo,
                "marca": marcaAuto,
                "esCeroKm": values.vehiculo.ceroKm,
                "tieneGnc": values.vehiculo.tieneGnc === "true" ? "1" : "0",
                "sumaAseguradaGnc": values.vehiculo.valorGnc,
                "sumaAseguradaAdicional": values.valorAdicional,
            },
            "situacionImpositiva": values.situacionImpositiva,
            "tipoPersona": values.personaJuridica,
            "nombreLocalidad": values.nombreLocalidad,
            "companies": companiesId,
            "fecha": moment().format('DD/MM/YYYY'),
            "codigoPostal": values.codigoPostal,
            "codigosLocalidad": values.codigosLocalidad,
            "idProvincia": values.idProvincia,
            "configuracionAvanzada": {
                ...fillAdvancedConfigByCompany(
                    companiesId,
                    values,
                    activeProducts?.[currentProduct]?.codigos_aseguradoras || [],
                    locationCodes,
                    localidadOptions,
                    polkoClientes
                )
            },
            "cliente": {
                "nombre": values.cliente.nombre,
                "apellido": values.cliente.apellido,
                "telefono": values.cliente.telefono,
                "email": values.cliente.email
            },
            "scoring": {
                "fechaNacimiento": values.cliente.fechaNacimiento,
                "sexo": "2"
            },
        }

        if (!polkoClientes) {
            jsonData['descuentos'] = {};
            companiesId.forEach(id => {
                const companyName = companiesIdDict[id];
                const descuento = activeProducts[currentProduct]['codigos_aseguradoras']
                    .find(el => el['id_aseguradora'] === id)?.['descuentos']?.['general'];

                if (descuento !== undefined) {
                    jsonData['descuentos'][companyName] = Math.max(
                        jsonData['descuentos'][companyName] || 0,
                        descuento
                    );
                }
            });

            values['descuentos'] = jsonData['descuentos'];
        }

        Axios.post(url, jsonData).then((res) => {
            setFinalValues(jsonData)
            if (res.data.idCotizar) {

                const formattedResponse = {
                    "idCotizar": res.data.idCotizar,
                    "vehicle": {
                        "year": values.vehiculo.anio,
                        "Marca": values.vehiculo.marca,
                        "Modelo": values.vehiculo.nombreModelo
                    },
                    "planCD": res.data
                }
                setCotizacionResponse(formattedResponse)
                actions.setSubmitting(false);
                setActiveStep(activeStep + 1);
            } else {
                setCotizacionResponse("Error");
                actions.setSubmitting(false);
            }
        }).catch(() => {
            setFinalValues(jsonData)
            setCotizacionResponse("Error");
            actions.setSubmitting(false);
        })
    }

    async function _emitirForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER;
        const formaDePagoCompanyValue = companiesDict[values.compania].codigoFormasDePago[values.formaDePago]
        const companyEquipoGncId = companiesDict[values.compania].equipoGncId

        let _telefono = formatPhoneNumberIntl(values.cliente.telefono).split(" ")
        let codArea = _telefono[1]
        let telefono = `${_telefono[1]}${_telefono[2]}${_telefono[3]}`

        url += '/newemitir';
        let premiumToSend = values.premium
        // if (values.compania === 'RUS') { //Premium fix for RUS
        //     premiumToSend = values.premium * values.parametrosAdicionales.cuotas
        // }
        if (values.vehiculo.tieneGnc === "true" && values.bienesAsegurados) {
            if (!values.bienesAsegurados.find(bien => bien['identificadorSancor'] === companyEquipoGncId)) {
                values.bienesAsegurados.push({
                    identificadorSancor: companyEquipoGncId,
                    descripcion: values.vehiculo.gnc.descripcionGnc,
                    monto: values.vehiculo.gnc.valorTotal
                })
            }
        }
        let jsonData = {
            "idCanalDigital": idRowPaginasPolkista,
            "sumaAseguradaGnc": values.vehiculo.valorGnc,
            "sumaAseguradaAdicional": values.vehiculo.valorAdicional,
            "tipoPersona": values.personaJuridica,
            "situacionImpositiva": values.situacionImpositiva,
            "codigosLocalidad": values.codigosLocalidad,
            "idProvincia": values.idProvincia,
            "nombreModelo": values.vehiculo.nombreModelo,
            "nombreLocalidad": values.nombreLocalidad,
            "codigoPostal": values.codigoPostal,
            "fecha": moment().format('YYYY-MM-DD'),
            "company": values.compania,
            "companyId": companiesDict[values.compania]['id'],
            "nombreCobertura": values.nombreCobertura,
            "vigenciaDesde": moment(values.vigenciaDesde).format('YYYY-MM-DD'),
            "vigenciaHasta": moment(values.vigenciaHasta).format('YYYY-MM-DD'),
            "formaDePago": formaDePagoCompanyValue,
            "infoDePago": {
                ...values.infoDePago
            },
            "clientes": [
                {
                    "rol": values.cliente.rol,
                    "tipoPersona": values.cliente.personaJuridica,
                    "dni": values.cliente.dni,
                    "cuit": values.cliente.cuit,
                    "nombre": values.cliente.nombre,
                    "apellido": values.cliente.apellido,
                    "fechaNacimiento": moment(values.cliente.fechaNacimiento).format('YYYY-MM-DD'),
                    "sexo": values.cliente.sexo,
                    "calle": values.cliente.calle,
                    "numero": values.cliente.numero,
                    "opcional": values.cliente.opcional,
                    "codigosLocalidad": values.codigosLocalidad,
                    "codigoPostal": values.codigoPostal,
                    "email": values.cliente.email,
                    "situacionImpositiva": values.cliente.situacionIva,
                    "codigoArea": codArea,
                    "telefono": telefono,
                }
            ],
            "comentariosSolicitud": values.comentariosSolicitud,
            "vehiculo": {
                ...values.vehiculo,
                "esCeroKm": values.vehiculo.ceroKm,
                "sumaAseguradaVehiculo": values.vehiculo.valor,
                "patente": values.vehiculo.patente,
                "motor": values.vehiculo.motor,
                "chasis": values.vehiculo.chasis,
                "gnc": {
                    "sumaAseguradaGnc": values.vehiculo.valorGnc,
                    "descripcionGnc": values.vehiculo.gnc.descripcionGnc,
                    "marcaRegulador": values.vehiculo.gnc.marcaRegulador,
                    "numeroRegulador": values.vehiculo.gnc.numeroRegulador,
                    "cilindros": [
                        ...values.vehiculo.gnc.cilindros,
                    ]
                },
                "bienesAdicionales": values.bienesAsegurados,
                "inspeccionPrevia": {
                    "fechaInspeccion": moment(values.vehiculo.inspeccionPrevia.fechaInspeccion).format('YYYY-MM-DD'),
                    "comentariosInspeccion": values.vehiculo.inspeccionPrevia.comentariosInspeccion,
                    "archivos": [
                        ...values.vehiculo.inspeccionPrevia.archivos,
                    ],
                    "daniosPreexistentes": false //TODO: Add
                }
            },
            "idCotizacion": values.idCotizar,
            "premio": premiumToSend,
            "idCobertura": values.selectedCobertura,
            "parametrosAdicionales": {
                ...values.parametrosAdicionales,
                'cuotas': values.cuotas,
                'descuentoEspecial': values.descuentos[values.compania] ?? 0,
                'idInstitucionFinanciera': values.formaDePago === 'TC' ? values.infoDePago.marcaTarjeta : formaDePagoCompanyValue,
                'idViaCobro': formaDePagoCompanyValue
            },
        }


        Axios.post(url, jsonData).then(res => {
            setEmisionResponse(res.data)
        }).catch((e) => {
            console.log(e)
            setEmisionResponse("Error")
        }).finally(() => {
            setFinalValues(values);
            actions.setSubmitting(false);
        });
    }

    function _handleSubmit(values, actions) {
        actions.setSubmitting(true);
        switch (activeStep) {
            case 0:
                setActiveStep(activeStep + 1);
                _cotizarForm(values, actions)
                break;
            case 4:
                setActiveStep(activeStep + 1);
                _emitirForm(values, actions);
                break;
            default:
                actions.setTouched({});
                actions.setSubmitting(false);
                setActiveStep(activeStep + 1);
                break;
        }
    }

    function _handleBack() {
        if (activeStep === 1) {
            setFinalValues(null)
        } else if (activeStep === 5) {
            setEmisionResponse(null)
        }
        setActiveStep(activeStep - 1);
    }

    const buttonText = () => {
        switch (activeStep) {
            case 0:
                return "Cotizar";
            case 4:
                return "Confirmar";
            default:
                return "Siguiente";
        }
    }

    return (
        <>
            <div className="form__circle__container">
                <div className="form__circle">
                    <IconCar className="form__icon--design"/>
                </div>
            </div>

            <div style={{margin: "16px 0px"}}>
                <ProgressBar activeStep={activeStep} stepTitles={steps}/>
            </div>

            <Fragment>
                <Formik
                    initialValues={customerAutomotorInitialValues}
                    validationSchema={currentValidationSchema}
                    validateOnBlur={false}
                    onSubmit={_handleSubmit}
                >
                    {({isSubmitting}) => (
                        <Form id={"customerAutomotorForm"}>
                            {
                                _renderStepContent(
                                    activeStep,
                                    cotizacionResponse,
                                    finalValues,
                                    modelos,
                                    setModelos,
                                    setActiveStep,
                                    setEmisionResponse,
                                    emisionResponse,
                                    currentProduct,
                                    localidadOptions,
                                    setLocalidadOptions,
                                    provinciasOptions,
                                    setProvinciasOptions,
                                )
                            }

                            <div
                                className="form__footer"
                                style={{display: activeStep > 4 && emisionResponse !== "Error" && "none"}}
                            >
                                {activeStep !== 0 && (emisionResponse === null || emisionResponse === "Error") && (
                                    <button
                                        type="button"
                                        onClick={_handleBack}
                                        className="button__outlined"
                                        disabled={isSubmitting}
                                    >
                                        Atras
                                    </button>
                                )}
                                {activeStep !== 1 && activeStep < 5 && (
                                    <button
                                        className="button"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        {buttonText()}
                                    </button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Fragment>
        </>
    );
}

function withAutomotorData(WrappedComponent) {
    return function WrappedWithAutomotorData(props) {
        const [loadingPage, setLoadingPage] = useState(true);
        const [errorPage, setErrorPage] = useState(null);
        const [automotorData, setAutomotorData] = useState(null);
        const {idRowPaginasPolkista} = useContext(ClienteDirectoContext);
        const {polkoClientes} = useContext(GenericDataContext)

        useEffect(() => {
            fetchContextData([() => loadAutomotorData(idRowPaginasPolkista, polkoClientes)], [setAutomotorData], setLoadingPage, ['CDAutomotorMarcas'])
                .then(errors => {
                        if (errors.length > 0) {
                            setErrorPage({
                                title: "Hubo un problema al cargar la información del usuario, por favor vuelva a intentarlo más tarde.",
                                typeError: "Ha ocurrido un error en la comunicación con el servicio",
                                suggestedActions: ["Reintentá el proceso una vez más", "Si el problema persiste ponete en contacto con el área de soporte"],
                                detailedError: errors[0].error.response?.data?.detail || "Sin datos del error",
                            })
                        }
                    }
                )
        }, []);

        if (loadingPage || errorPage) return <Loading/>

        return (
            <AutomotorContextProvider initialData={automotorData}>
                <WrappedComponent {...props} />
            </AutomotorContextProvider>
        );
    };
}

export default withAutomotorData(CheckoutCotizar);